export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-12 md:pt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-8 md:py-14">
          <div className="w-full lg:w-1/2 bg-[#1E3A47] rounded-2xl p-8 md:p-12 text-white">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
              Réparation de fenêtre à Erstein
            </h1>
            <p className="md:hidden text-base text-white/90 mb-4 leading-relaxed">
              Fenêtre qui ferme mal, bloquée, crémone ou poignée cassée à Erstein ? Réparation à domicile, pièce comprise, devis gratuit.
            </p>
            <p className="hidden md:block text-base md:text-lg text-white/90 mb-8 leading-relaxed">
              Erstein, au sud de Strasbourg, connaît une expansion résidentielle rapide. Entre les lotissements neufs et le centre historique alsacien, les fenêtres courent du PVC moderne au bois traditionnel. Nos techniciens réparent le mécanisme chez vous, pièce comprise, déplacement gratuit.
            </p>
            <div className="md:hidden flex flex-wrap gap-x-3 gap-y-1 mb-4 text-white/70 text-xs">
              <span className="whitespace-nowrap">Intervention 24h</span>
              <span className="text-white/40">·</span>
              <span className="whitespace-nowrap">Devis &amp; déplacement gratuits</span>
              <span className="text-white/40">·</span>
              <span className="whitespace-nowrap">Pièce comprise</span>
              <span className="text-white/40">·</span>
              <span className="whitespace-nowrap">Garantie 10 ans</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:0374471036"
                className="bg-[#FF6B4A] text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-[#FF6B4A]/90 transition-colors whitespace-nowrap cursor-pointer text-center flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                Appeler le 03 74 47 10 36
              </a>
              <a
                href="#devis"
                className="border border-white/40 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Devis gratuit
              </a>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="rounded-2xl overflow-hidden h-64 md:h-80 lg:h-96">
              <img
                src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/23eb1b95702aea6f23d59e6631489d05.jpeg"
                alt="Rue résidentielle d'Erstein avec maisons et fenêtres"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 pb-6 md:pb-8">
          <div className="flex items-center gap-2 text-[#243038] text-sm">
            <i className="ri-check-double-line text-[#1E3A47] w-5 h-5 flex items-center justify-center" />
            Plus de 90 % de réparations réussies
          </div>
          <div className="flex items-center gap-2 text-[#243038] text-sm">
            <i className="ri-check-double-line text-[#1E3A47] w-5 h-5 flex items-center justify-center" />
            Déplacement et devis gratuits
          </div>
          <div className="flex items-center gap-2 text-[#243038] text-sm">
            <i className="ri-check-double-line text-[#1E3A47] w-5 h-5 flex items-center justify-center" />
            Pièce comprise dans l'intervention
          </div>
        </div>
      </div>
    </section>
  );
}